module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticStyle: {
      "width": "30%",
      "float": "left"
    }
  }, [_c('sidebar', {
    ref: "side",
    attrs: {
      "current": "a",
      "surface": _vm.surface1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p0002",
    staticStyle: {
      "width": "48%",
      "float": "left"
    }
  }, [_c('sidebar', {
    attrs: {
      "current": "b",
      "surface": _vm.surface
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p0002",
    staticStyle: {
      "width": "20%",
      "float": "left"
    }
  }, [_c('sidebar', {
    attrs: {
      "curl": true,
      "current": "b",
      "surface": _vm.surface
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row m2000"
  }, [_c('div', {
    staticStyle: {
      "width": "30%",
      "float": "left"
    }
  }, [_c('sidebar', {
    attrs: {
      "theme": "white",
      "size": "sm",
      "current": "a"
    }
  }, _vm._l((_vm.surface), function(item) {
    return _c('sidebar-item', {
      attrs: {
        "alias": item.alias,
        "title": item.title,
        "icon": item.icon
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "p0002",
    staticStyle: {
      "width": "48%",
      "float": "left"
    }
  }, [_c('sidebar', {
    attrs: {
      "theme": "white",
      "size": "sm",
      "current": "a",
      "surface": _vm.surface
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p0002",
    staticStyle: {
      "width": "20%",
      "float": "left"
    }
  }, [_c('sidebar', {
    attrs: {
      "curl": true,
      "theme": "white",
      "size": "sm",
      "current": "b",
      "surface": _vm.surface
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "divi"
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "css": {
        width: '300px'
      },
      "curl": _vm.curl,
      "current": "b",
      "surface": _vm.surface
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p2000",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary-blank",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.setCurl(true)
      }
    }
  }, [_vm._v("缩起菜单")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary-blank",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.setCurl(false)
      }
    }
  }, [_vm._v("打开菜单")])]), _vm._v(" "), _c('div', {
    staticClass: "divi"
  }), _vm._v(" "), _c('sidebar', {
    ref: "sidebar",
    attrs: {
      "css": {
        width: '300px'
      },
      "theme": "light",
      "current": _vm.current,
      "surface": _vm.surface
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p2000",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary-blank",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.setCurrent('a')
      }
    }
  }, [_vm._v("选中一")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary-blank",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.setCurrent('b')
      }
    }
  }, [_vm._v("选中二")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary-blank",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.setCurrent('c')
      }
    }
  }, [_vm._v("选中三")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f372760!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/demo.vue
// module id = 236
// module chunks = 36